export const categoryDropdown = [
  {
    id: 1,
    name: "Electronics",
  },
  {
    id: 2,
    name: "Cell Phones and Accessories",
  },
  {
    id: 3,
    name: "Jewelary and Gemstones",
  },
  {
    id: 4,
    name: "Property",
  },
  {
    id: 5,
    name: "Home and Living",
  },
  {
    id: 6,
    name: "Clothing, Shoes and Accessories",
  },
  {
    id: 7,
    name: "Car and Bikes",
  },
  {
    id: 8,
    name: "Car Parts and Accessories",
  },
  {
    id: 1,
    name: "Boots and Watercraft",
  },
];
